import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Platform, LoadingController, AlertController } from '@ionic/angular';
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';


//import 'rxjs/add/operator/map';
//import 'rxjs/Rx';


@Injectable({
  providedIn: 'root'
})
export class PortalService {

  constructor(public http: HttpClient, public plt: Platform, public loading: LoadingController) {

  }


  result: any;
  baseURL: any = "https://adopendayapi.azurewebsites.net/api/default/";
  //baseURL: any = "http://localhost:14118/api/default/";


  //Portal functions
  /**
       int Id 
       string FullName 
       string Email 
       string Mobile 
       int CertificateTypeId 
       int InviteMembers 
       Guid RegistrationId 
       List<int> SelectedFaculty 
   */


  GetFaculty() {
    return this.CallPortalGet('GetFaculty');
  }

  GetFacultyConfig(item) {
    return this.CallPortalPost('GetFacultyConfig', item);
  }

  GetCertificate() {
    return this.CallPortalGet('GetCertificate');
  }

  GetSlots() {
    return this.CallPortalGet('GetSlot');
  }

  GetGender() {
    return this.CallPortalGet('GetGender');
  }

  GetGrade() {
    return this.CallPortalGet('GetGrade_DNT');
  }

  Register(item: any) {
    return this.CallPortalPost('Register', item);
  }

  SendIvitationEmail(item: any) {
    return this.CallPortalPost('SendIvitationEmail', item);
  }



  CallPortalGet(methodURL: string) {
    return this.CallPortalGet_base(this.baseURL, methodURL);
  }


  CallPortalGet_base(baseURL: string, methodURL: string) {
    return new Promise(resolve => {
      this.http.get(baseURL + methodURL)

        .subscribe(data => {
          console.log(data);
          this.result = data;
          resolve(this.result);
        }, Error => {
          console.error(Error);
          resolve(Error);
        });
    });
  }


  CallPortalPost(methodURL: string, obj: any) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + methodURL, obj).pipe(
        map(res => res))
        .subscribe(data => {
          this.result = data;
          resolve(this.result);
        }, Error => {
          console.error(Error);
          resolve(Error);
        });
    });
  }


}
@Injectable()
export class FilterPipe {

  transform(value: any, args?: any): any {
    var unique = {};
    var uniqueList = [];
    for (var i = 0; i < value.length; i++) {
      if (typeof unique[value[i][args]] == "undefined") {
        unique[value[i][args]] = "";
        uniqueList.push(value[i]);
      }
    }
    return uniqueList;
  }

}

@Injectable()
export class Utils {

  constructor(public alertCtrl: AlertController, public platform: Platform, public loading: LoadingController, public router: Router) { }

  CloseApp() {
    navigator['app'].exitApp();
  }


  PresentConnectionErrorAlert(retryFun: Function) {
    var here = this;
    this.Present2ButtonsAlert('Error', 'Connection Error', 'Exit', function () { here.CloseApp(); }, 'Retry', retryFun);
  }

  PresentErrorAlert(retryFun: Function) {
    var here = this;
    this.Present2ButtonsAlert('Error', 'Error, Please Try again Later', 'Exit', function () { here.CloseApp(); }, 'Retry', retryFun);
  }

  async Present2ButtonsAlert(title: string, message: string, button1: string, button1Func: Function, button2: string, button2Func: Function) {
    let alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {
          text: button1,
          handler: () => {
            button1Func();
          }
        },
        {
          text: button2,
          handler: () => {
            button2Func();
          }
        }
      ]
    });
    alert.present();
  }


  PresentExitAlert(title: string, message: string) {
    var here = this;
    this.PresentButtonAlert(title, message, 'Close', function () { here.CloseApp(); });
  }

  async PresentButtonAlert(title: string, message: string, button1: string, button1Func: Function) {
    let alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {
          text: button1,
          handler: () => {
            button1Func();
          }
        }
      ]
    });
    alert.present();
  }

  async PresentOkAlert(title: string, message: string) {
    let alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: ['Ok']
    });
    alert.present();
  }
}
